import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M5.392 20h9.907c1.93 0 2.891-.98 2.891-2.92V8.61c0-1.203-.14-1.726-.886-2.49L12.164.885C11.455.16 10.868 0 9.823 0H5.392C3.47 0 2.5.989 2.5 2.93v14.15c0 1.95.96 2.92 2.892 2.92m.065-1.502c-.96 0-1.455-.513-1.455-1.446V2.957c0-.923.494-1.455 1.464-1.455h4.152v5.42c0 1.175.587 1.753 1.753 1.753h5.317v8.377c0 .933-.494 1.446-1.464 1.446zM11.54 7.267c-.373 0-.513-.15-.513-.523V1.791L16.4 7.267z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "M13.778 11.25h-7.08a.57.57 0 0 0-.588.57c0 .325.252.577.588.577h7.08a.56.56 0 0 0 .569-.578.56.56 0 0 0-.57-.569M13.778 14.506h-7.08a.58.58 0 0 0-.588.588c0 .317.252.56.588.56h7.08a.55.55 0 0 0 .569-.56.57.57 0 0 0-.57-.588"
    }, null, -1)
  ])))
}
export default { render: render }